let initialState = {
	dashboard: {},
	dashboardCustomers: {},
	dashboardPayments: {},
	productSales: [],
	membershipSales: [],
};

const mergeDashboardData = (customers = {}, payments = {}) => {
	const customersGroupByMonth = customers?.groupByMonth || {};
	const paymentsGroupByMonth = payments?.groupByMonth || {};

	return {
		...payments,
		...customers,
		thisMonthData: {
			...(payments?.thisMonthData || {}),
			...(customers?.thisMonthData || {}),
		},
		groupByMonth: {
			...paymentsGroupByMonth,
			...customersGroupByMonth,
		},
	};
};

const dashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'LOGOUT': {
			return initialState;
		}

		case 'GET_DASHBOARD_DATA':
			return {
				...state,
				dashboard: action.payload,
			};
		case 'GET_DASHBOARD_CUSTOMERS': {
			const dashboardCustomers = action.payload || {};
			return {
				...state,
				dashboardCustomers,
				dashboard: mergeDashboardData(dashboardCustomers, state.dashboardPayments),
			};
		}
		case 'GET_DASHBOARD_PAYMENTS': {
			const dashboardPayments = action.payload || {};
			return {
				...state,
				dashboardPayments,
				dashboard: mergeDashboardData(state.dashboardCustomers, dashboardPayments),
			};
		}
		case 'GET_PRODUCTS_SALE':
			return {
				...state,
				productSales: action.payload,
			};
		case 'GET_MEMBERSHIP_SALE':
			return {
				...state,
				membershipSales: action.payload,
			};
		default:
			return state;
	}
};

export { dashboardReducer };
